import React from 'react';
import Modal from '../modal';

import { PDFImageProps } from '../../../utils/models';

import classNames from './style.module.scss';

const Image: React.FC<PDFImageProps> = (props) => {
	const [isVisible, setIsVisible] = React.useState<boolean>(false);

	const toggleVisibility = (): void => {
		setIsVisible((p: boolean) => !p);
	};

	return (
		<React.Fragment>
			<Modal isVisible={isVisible} onClose={toggleVisibility}>
				<img
					src={props.src}
					alt={props.caption}
					className={classNames['pid-card-lighthouse']}
				/>
			</Modal>

			<div className={classNames['pid-card']}>
				<button type="button" onClick={toggleVisibility}>
					<img
						src={props.src}
						alt={props.caption}
						className={classNames['pid-card-image']}
					/>

					<div className={classNames['pid-card-detail']}>{props.caption}</div>
				</button>
			</div>
		</React.Fragment>
	);
};

export default Image;
